import { match } from '../utilities/ResolutionHandler';
import { get, CancelToken } from '../libs/Axios';
import DropdownComponent from './DropdownComponent';
import { DataLayerUtils } from '../utilities/DataLayer';

export default class MiniCartComponent extends DropdownComponent {
  get Messages() {
    return {
      [this.CUSTOM_MESSAGES.ADDTOCART_EVENTS.itemAdded]: this.showMiniCart
    };
  }

  constructor(element) {
    super(element);
  }

  async getContent(newItem) {
    const { token, cancel } = CancelToken.source();
    const cancelToken = token;
    const res = {};
    this.cancel = cancel;
    res.classes = [];
    res.numItems = [];
    const cartInfo = await get(this.$options.cartinfo);
    this.showCartSize(cartInfo.data.numItems);
    const cart = await get(this.$options.minicarturl, {
      cancelToken,
      params: {
        newItem
      }
    });


    res.cart = cart.data;

    if (cartInfo.data && !cartInfo.data.numItems) res.classes.push('minicart-empty');
    res.numItems.push(cartInfo.data.numItems);
    return res;
  }

  close() {
    if (this.cancel) this.cancel('mouse out minicart');
    super.close();
  }

  async open(newItem) {
    try {
      clearTimeout(this.quickViewTimeout);
      const { classes, cart } = await this.getContent(newItem);
      if (!this.IS_OPEN && match(null, 'medium')) super.open(cart, [...classes]);
      if (match('medium')) this.EMIT(this.CUSTOM_MESSAGES.MODAL_EVENTS.show, { unsafeContent: cart, className: 'not-full-height' });
    } catch (err) {
      console.error(err);
    }
  }

  async showMiniCart() {
    clearTimeout(this.quickViewTimeout);
    const res = await this.getContent();
    const response = res.cart;
    const wrapper = document.createElement('div');
    wrapper.innerHTML = response;
    const variant = wrapper.querySelector('.js-variation').getAttribute('data-option-variant');
    const sku = wrapper.querySelector('.js-variation').getAttribute('data-option-sku');

    this.open(true).then(() => {
      this.quickViewTimeout = setTimeout(() => {
        if (res.numItems == 1) {
          DataLayerUtils.push({
            gaHitType: 'event',
            event: 'goal_event',
            eventCategory: 'cart_created',
            eventAction: sku + '|' + variant
          });
        }
        this.close();
      }, 3000);
    });
  }

  async showCartSize(size) {
    if (size > 0) {
      this.PARENT.classList.add(this.CLASSES.dot);
      this.$el.setAttribute('data-content-size', size);
      if (size > 9) {
        this.$el.setAttribute('data-content-size', '9+');
      }
    } else {
      this.PARENT.classList.remove(this.CLASSES.dot);
      this.$el.removeAttribute('data-content-size');
    }
  }

  bindEvents() {
    this.bindHover();
  }
}
